export const GET_ACTIVITY_LOG_SUCCEED = 'GET_ACTIVITY_LOG_SUCCEED'
